module.exports = __webpack_public_path__ + "static/media/Path23690.068b98dc.svg";